import { Box, Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { IntExt } from '../lib/permissions';
import { routes_to_hide_navbar } from '../lib/static_values';
import UserService from '../services/UserService';

function App1() {

  const { pathname } = useLocation();
  const is_external = UserService.hasRole([IntExt.External]);

  return (<>
    {/* <h1>App 1</h1>
    {'Is This My Username ' + JSON.stringify(UserService.getFullName())}
    <h3>Change Content of App 3</h3> */}
    <Box display={routes_to_hide_navbar.includes(pathname.split('/').filter(Boolean)[0])
      ? 'none'
      : 'flex'} flexWrap='wrap'>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/location'}>Τοποθεσίες</Button>
      </Box>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/professionals'}>Επαγγελματίες</Button>
      </Box>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/register'}>Εγγραφή</Button>
      </Box>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/search-collections'}>Αναζήτηση στις Συλλογές</Button>
      </Box>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/search-documents'}>Αναζήτηση στους Φορείς</Button>
      </Box>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/search-organisation'}>Αναζήτηση Φορεών</Button>
      </Box>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/collections'}>Συλλογές</Button>
      </Box>
      <Box m={2}>
        <Button color='secondary' variant='contained'
          onClick={() => window.location.hash = '/search-projects'}>Αναζήτηση Έργων</Button>
      </Box>
      {(!is_external && UserService.isAuthenticated()) &&
        <Box m={2}>
          <Button color='secondary' variant='contained'
            onClick={() => window.location.hash = '/admin/units/dashboard'}>Διαχειριστικό</Button>
        </Box>
      }
    </Box>
  </>
  );
}

export default App1;